export function useRouteParams<T extends Record<string, string>>() {
  const pageContext = usePageContext();

  return reactiveComputed(() => pageContext.routeParams as T);
}
